export default __webpack_public_path__ + "static/media/Threeh 2.eada6931.jpg";